import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useT } from '../i18n/LangContext';
import LangToggle from '../components/LangToggle';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/+$/, '');

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { t } = useT();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await fetch(`${API_BASE}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error?.message || 'Login failed');
      localStorage.setItem('adminToken', data.token);
      navigate('/admin');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.langRow}>
        <LangToggle />
      </div>
      <div style={styles.card}>
        <div style={styles.logo}>FORMLY HR</div>
        <p style={styles.sub}>{t('adminPanelSub')}</p>
        <form onSubmit={onSubmit} style={styles.form}>
          <input
            style={styles.input}
            type="email"
            placeholder={t('adminEmail')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
          <input
            style={styles.input}
            type="password"
            placeholder={t('adminPassword')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.btn} type="submit" disabled={busy}>
            {busy ? t('adminSigningIn') : t('adminSignIn')}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f4f5f7',
    fontFamily: 'Inter, sans-serif',
  },
  langRow: {
    position: 'fixed',
    top: '16px',
    right: '20px',
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    padding: '48px 40px',
    width: '360px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    textAlign: 'center',
  },
  logo: {
    fontSize: '22px',
    fontWeight: 700,
    letterSpacing: '0.05em',
    color: '#1a1a2e',
    marginBottom: '4px',
  },
  sub: {
    fontSize: '13px',
    color: '#888',
    marginBottom: '32px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  input: {
    padding: '11px 14px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '14px',
    outline: 'none',
  },
  btn: {
    padding: '12px',
    borderRadius: '8px',
    background: '#5b6af0',
    color: '#fff',
    border: 'none',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: '4px',
  },
  error: {
    color: '#e74c3c',
    fontSize: '13px',
    margin: 0,
  },
};
